// SelectedSummary.jsx
import React from "react";
import {
  Box,
  Typography,
  Divider,
  Button,
  ListItem,
  useTheme,
} from "@mui/material";
import { useSelectedOptions } from "../../context/SelectedOptionsContext";
import {
  SelectedSummaryRoot,
  SelectedSummaryHeader,
  SelectedSummaryContent,
  SelectedSummaryFooter,
} from "./SelectedSummary.styles";
import wydstLogo from "../../assets/WYDST_R8S_logo.svg";

const currency = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
});

export const SelectedSummary = ({ onHandleToggle, showInterface }) => {
  const { items, subtotal, openSummary } = useSelectedOptions();
  const theme = useTheme();

  const filteredItems = items.filter(
    (item) =>
      (item?.inSummary !== false || item?.inSummary !== null) && item?.price > 0
  );

  return (
    <SelectedSummaryRoot>
      <SelectedSummaryHeader
        onClick={() => onHandleToggle(showInterface)}
        sx={{
          pointerEvents: showInterface ? "none" : "auto",
          cursor: showInterface ? "default" : "pointer",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 500, flex: 1 }}>
          Summary
        </Typography>
        <Box
          component="img"
          src={wydstLogo}
          alt="Fallback"
          sx={{
            width: "160px",
            mt: "2px",
            display: "block",
            zIndex: 1,
          }}
        />
      </SelectedSummaryHeader>
      <SelectedSummaryContent dense>
        {filteredItems.map((it, indexIt) => {
          return (
            <React.Fragment key={it.groupKey}>
              <ListItem>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    flex: 1,
                  }}
                >
                  {it.subCategory && (
                    <Typography variant="body1" sx={{ fontSize: "1.35rem" }}>
                      {it.subCategory}
                    </Typography>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      margin: it.name ? "5px 0 -1px" : 0,
                    }}
                  >
                    {it.name && (
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 500,
                          lineHeight: 1,
                          fontSize: "1.1rem",
                        }}
                      >
                        {it.name}
                      </Typography>
                    )}
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        fontSize: it.name ? "1.1rem" : "1.25rem",
                      }}
                      color={
                        it.name
                          ? theme.palette.companyColors.greyLight1
                          : theme.palette.companyColors.secondary
                      }
                    >
                      {currency.format(Number(it.price) || 0)}
                    </Typography>
                  </Box>
                </Box>
              </ListItem>
              {filteredItems.length !== indexIt + 1 && (
                <Divider
                  component="li"
                  sx={{
                    width: "90%",
                    margin: "auto",
                    borderColor: theme.palette.companyColors.greyLight1,
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </SelectedSummaryContent>

      <SelectedSummaryFooter>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            Total
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 800,
              letterSpacing: "-1px",
              fontSize: { xs: "2.25rem", lg: "2rem", xl: "2.5rem" },
              fontFamily: "Onest",
            }}
          >
            {currency.format(subtotal)}*
          </Typography>
        </Box>
        <Button
          sx={{
            color: theme?.palette?.companyColors?.neutral,
            background: theme?.palette?.companyColors?.accent,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            borderRadius: theme?.borderRadius?.small,
            padding: { xs: "0.9rem 5rem", lg: "1rem 1.5rem", xl: "1rem 2rem" },
          }}
          onClick={() => {
            openSummary();
          }}
        >
          <Typography
            variant="button"
            sx={{
              textTransform: "initial",
              fontSize: { xs: "1.75rem", lg: "1.5rem", xl: "1.75rem" },
              fontWeight: 400,
            }}
          >
            {/* uncomment after the event */}
            {/* I'm Interested */}
            Open summary
          </Typography>
        </Button>
      </SelectedSummaryFooter>
    </SelectedSummaryRoot>
  );
};
